import Vue from 'vue';
import VueCookie from 'vue-cookie';
import { SlbOperationConstant, CreateTypeConstant } from './Constants';
import { formatLocale } from './localeUtil';

const SlbPopHelper = {};

// 中英文对应不同的样式（some questions here
const getClass = () => {
  const loc = formatLocale(VueCookie.get('jdcloud_sitelang'));
  if (loc === 'zh-CN') {
    return { style: 'text-align: left;' };
  }
  return { style: 'text-align: left; word-break: keep-all' };
};

export function operations(caseOps, target, params, type, disabled) {
  const param = {
    region: params.region,
    loadBalancerId: params.loadBalancerId,
  };
  switch (parseInt(caseOps)) {
    // 开启
    case SlbOperationConstant.OPEN: {
      if (params.publicIp === undefined) {
        return false;
      }
      const h = target.$createElement;
      target.$msgbox({
        title: target.$t('slb.text.openSlb'),
        message: h('p', getClass(), [
          h('span', null, target.$t('slb.sentence.openSlb', [params.name])),
        ]),
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: target.$t('popHelper.text.sure'),
        cancelButtonText: target.$t('popHelper.text.cancel'),
      }).then(() => {
        Ajax.put('/api/cps/slbs/startLoadBalancer', param)
          .then(() => {
            if (type === 'list') {
              target.updateList('refresh');
            } else if (type === 'detail') {
              target.getSlbDetail();
            }
          })
          .catch(async (err) => {
            const { response } = err.data;
            try {
              const json = await response.json();
              target.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
          });
      });
      break;
    }
    // 关闭
    case SlbOperationConstant.CLOSE: {
      const h = target.$createElement;
      target.$msgbox({
        title: target.$t('slb.text.closeSlb'),
        message: h('p', getClass(), [
          h('span', null, target.$t('slb.sentence.closeSlb', [params.name])),
        ]),
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: target.$t('popHelper.text.sure'),
        cancelButtonText: target.$t('popHelper.text.cancel'),
      }).then(() => {
        Ajax.put('/api/cps/slbs/stopLoadBalancer', param)
          .then(() => {
            if (type === 'list') {
              target.updateList('refresh')();
            } else if (type === 'detail') {
              target.getSlbDetail();
            }
          })
          .catch(async (err) => {
            const { response } = err.data;
            try {
              const json = await response.json();
              target.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
          });
      });
      break;
    }
    // 续费
    case SlbOperationConstant.RENEW: {
      Ajax.get({
        url: '/api/order',
        action: '/submitRenew',
        param: {
          region: params.region,
          resourceId: params.loadBalancerId,
          serviceCode: CreateTypeConstant.SLB
        },
        success: (data) => {
          if (type !== 'detail') {
            target.updateList('refresh');
          }
          window.location.href = `${Vue.prototype.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${data.tmpOrderId}&resourceType=${CreateTypeConstant.SLB}`;
        },
      });
      break;
    }

    case SlbOperationConstant.UNBIND: {
      const h = target.$createElement;
      target.$msgbox({
        title: target.$t('privateNetInstance.unBindTitle'),
        message: h('p', getClass(), [
          h('span', null, target.$t('privateNetInstance.sureUnBindTip', [params.publicIp])),
        ]),
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: target.$t('popHelper.text.sure'),
        cancelButtonText: target.$t('popHelper.text.cancel'),
      }).then(() => {
        const unbindParams = {
          region: params.region,
          loadBalancerId: params.loadBalancerId,
          elasticIpId: params.elasticIpId
        };
        Ajax.put('/api/cps/slbs/disassociateElasticIp', unbindParams)
          .then(() => {
            if (type === 'list') {
              target.updateList('refresh')();
            } else if (type === 'detail') {
              target.getSlbDetail();
            }
          })
          .catch(async (err) => {
            const { response } = err.data;
            try {
              const json = await response.json();
              target.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          }).finally(() => {
          });
      });
      break;
    }

    case SlbOperationConstant.EDITTAG: {
      target.rowInfo = params;
      target.editTagDialogVisible = true;
      break;
    }

    case SlbOperationConstant.DELETE: {
        target.rowInfo = params;
        target.deleteSlbVisible = true;
        break;
    }
  }
}

/**
 * 删除虚拟服务器组
 * @param target
 * @param params
 * @param type
 */
export function remove_virtual_servers(target, params, type) {
  const h = target.$createElement;

  target.$msgbox({
    title: target.$t('slb.serverGroup.deleteVirtualServerGroup'),
    message: h('p', getClass(), [
      h('span', null, target.$t('slb.sentence.deleteVirtualServerGroupTip', [params.name])),
    ]),
    closeOnClickModal: false,
    showCancelButton: true,
    cancelButtonText: target.$t('popHelper.text.cancel'),
    confirmButtonText: target.$t('popHelper.text.sure'),
  }).then(() => {
    const delParams = {
      serverGroupId: params.serverGroupId,
      region: params.region,
    };
    Ajax.del('/api/cps/serverGroups', delParams)
      .then()
      .catch(async (err) => {
        const { response } = err.data;
        try {
          const json = await response.json();
          target.$message.error(json.errmsg);
        } catch (ex) {
          console.log(ex);
        }
      })
      .finally(() => {
        if (type === 'list') {
          target.refreshGroupList({});
          console.log('list');
        } else if (type === 'detail') {
          target.goBack();
        }
      });
  });
}

export default SlbPopHelper;



// WEBPACK FOOTER //
// ./src/common/SlbPopHelper.js